/* eslint-disable camelcase */

export default class DtoPgsseActivity {
    constructor(obj) {
        this.idDiagnostic = obj.idDiagnostic
        this.category = obj.category
        this.lexId = obj.lexId
        this.otherActivityName = obj.otherActivityName
        this.regie = obj.regie
        this.delegation = obj.delegation
        this.updateDate = obj.updateDate
        this.updateLogin = obj.updateLogin
        this.comment = obj.comment

        this.toUpdate = true
        this.index = obj.index
    }
}
